import styled from 'styled-components';

import { NewModalProps } from '.';

export const Container = styled.div<Pick<NewModalProps, 'visible'>>`
  position: absolute;
  top: 75px;
  bottom: calc(100vh - var(--height-full));
  left: 0;
  right: 0;
  width: 100%;
  background: #fff;
  z-index: ${({ visible }) => (visible ? 55 : 0)};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
  transition: opacity 350ms ease-in-out;
  display: flex;
  flex-direction: column;
`;

export const CloseWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 32px;
  padding-top: 32px;

  div {
    display: flex;
  }
`;

export const CloseIcon = styled.img`
  cursor: pointer;
`;

export const CloseTitle = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #555658;
`;

export const RightText = styled.h1`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #004f92;
  cursor: pointer;
`;
